import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { BranchEditing } from 'entities/Branches/interfaces';
import { FieldArray, useFormikContext } from 'formik';
import { isEqual } from 'lodash';
import { getUniqueAadRequest } from 'modules/admin/containers/BranchEditing/actions';
import { Input, MultyInput, Select } from 'modules/shared/Forms';
import { useDebounce } from 'modules/shared/hooks';
import TitleUndescore from 'modules/shared/TitleUndescore';
import { useDispatch } from 'react-redux';
import { trims } from 'utils';

import styles from 'modules/shared/Forms/MultyInput/MultyInput.module.scss';

type Props = {
  values: BranchEditing;
  onChange: (e: React.ChangeEvent<any>) => void;
};

const labels = {
  '1': 'Значення ролі Azure "Менеджер" (ARM_MANAGER)',
  '3': 'Значення ролі Azure "Охорона" (ARM_OHRANA)',
  '4': 'Значення ролі Azure "Виписка" (ARM_VYPISKA)',
  '2': 'Значення ролі Azure "Завсклад" (ARM_DIRECTOR)',
  '6': 'Значення ролі Azure "Кіоск" (ARM_KIOSK)',
  '7': 'Значення ролі Azure "TV-панель" (ARM_TVPANEL)',
};

const BranchDataCard: React.FC<Props> = ({ onChange, values }) => {
  const dispatch = useDispatch();
  const { securityGates, aadRoles } = values;

  const { touched, setFieldTouched } = useFormikContext();
  const debAadRoles = useDebounce(aadRoles, 1500);

  const [arrDoubles, setArrDoubles] = useState<number[]>([]);

  const checkDoublesRoles = () => {
    const uniqValues = [] as string[];
    const doubles = [] as number[];

    debAadRoles.forEach((doc: any, index: number) => {
      const str = trims(`${doc.objectId}`.toLowerCase());

      if (uniqValues.includes(str)) {
        doubles.push(index);
      } else {
        uniqValues.push(str);
      }
    });

    doubles.forEach((arr: number) => {
      setFieldTouched(`aadRoles[${arr}].objectId`);
    });

    setArrDoubles(doubles);

    const arr: string[] = [];

    debAadRoles.forEach((a: any) => arr.push(a.objectId));
    return dispatch(getUniqueAadRequest(arr));
  };

  useEffect(() => {
    if (isEqual(aadRoles, debAadRoles)) checkDoublesRoles();
  }, [debAadRoles]);

  return (
    <div className="my-5">
      <TitleUndescore title="Дані філії" />
      <div className="pl-4">
        <Input onChange={onChange} label="Ім'я філії" className="mb-2" name="name" isRequiredAtStart />
        <Input onChange={onChange} label="Адреса" className="mb-2" name="address" isRequiredAtStart />
        <Select
          label="Порядок роботи філії"
          className="mb-2"
          name="operatingProcedure"
          helpText="Оберіть порядок роботи"
          onChange={onChange}
        >
          <option value="Порядок 1">Порядок 1 (Охорона-Виписка-Завантаження-Виписка-Охорона)</option>
          <option value="Порядок 2">Порядок 2 (Виписка - Охорона - Завантаження-Виписка-Охорона)</option>
          <option value="Порядок 3">Порядок 3 (Виписка - Завантаження - Виписка)</option>
        </Select>
        <MultyInput
          label="Пости охорони"
          onChange={onChange}
          name="securityGates"
          value={securityGates}
          isRequiredAtStart
        />

        <FieldArray
          name="aadRoles"
          render={() =>
            aadRoles?.map((v: any, index: number) => {
              const { roleId } = v;
              const isExist =
                !!arrDoubles.length &&
                !!arrDoubles.find((a: number) => a === index) &&
                Object.keys(touched).includes('aadRoles') &&
                // @ts-ignore
                touched?.aadRoles[index]?.objectId;

              if (Object.keys(labels).includes(`${roleId}`))
                return (
                  <div className="position-relative">
                    <Input
                      key={roleId}
                      name={`aadRoles[${index}].objectId`}
                      // @ts-ignore
                      label={labels[`${roleId}`]}
                      maxLength={50}
                      className={classNames(isExist && styles.isInputErr, 'mb-2')}
                      value={v.objectId}
                      onChange={onChange}
                      isRequiredAtStart
                    />
                    {isExist && <h5 className={styles.errormsgRoles}>Вже є у списку</h5>}
                  </div>
                );

              return true;
            })
          }
        />
      </div>
    </div>
  );
};

export default BranchDataCard;
